// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion___0aM_","contentWrapper":"styles_contentWrapper__GYO34","content":"styles_content__FFtZX"};